import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Badge } from '../badge';

export const meta = {
  argTypes: {
    iconEnd: { table: { disable: true } },
    iconStart: { table: { disable: true } },
    label: { table: { disable: true } },
    palette: { table: { disable: true } },
    size: { table: { disable: true } },
    width: { table: { disable: true } },
  },
  args: {
    iconEnd: '',
    iconStart: '',
    label: 'Badge label',
    palette: '',
    size: '',
    width: '',
  },
  title: 'Components/Badge/',
};

interface Story {
  iconEnd: Badge['iconEnd'];
  iconStart: Badge['iconStart'];
  label: string;
  palette: Badge['palette'];
  size: Badge['size'];
  width: Badge['width'];
}

export const story = ({ iconEnd, iconStart, label, palette, size, width }: Story) => html`
  <abds-badge
    icon-end="${ifDefined(iconEnd || undefined)}"
    icon-start="${ifDefined(iconStart || undefined)}"
    palette="${ifDefined(palette || undefined)}"
    size="${ifDefined(size || undefined)}"
    width="${ifDefined(width || undefined)}"
  >
    ${label}
  </abds-badge>
`;

export default { meta, story };
